exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-typeahead .selectize-input{box-shadow:none;border-color:#bbb}adp-typeahead .selectize-control.multi .selectize-input>div{background:#1a8099;border-radius:2px;font-size:14px;font-family:ProximaNova-semibold;color:#fff;height:26px;line-height:22px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpTypeahead/adpTypeahead.less
// module id = 732
// module chunks = 0